
// Generated from x-tvstor-permission — do not edit.

export const PERMISSION_CATALOG = [
    "alerts.manage",
    "backup.create",
    "backup.delete",
    "backup.read",
    "backup.restore",
    "backupTarget.create",
    "backupTarget.delete",
    "backupTarget.read",
    "backupTarget.update",
    "catalogsource.create",
    "catalogsource.delete",
    "catalogsource.read",
    "catalogsource.update",
    "cephcluster.create",
    "cephcluster.delete",
    "cephcluster.grow",
    "cephcluster.read",
    "cephcluster.update",
    "chunk.create",
    "chunk.delete",
    "chunk.read",
    "cluster.audit.read",
    "cluster.node.add",
    "cluster.node.fencing",
    "cluster.node.keystore",
    "cluster.node.maintain",
    "cluster.node.remove",
    "cluster.node.update",
    "cluster.read",
    "cluster.store.member",
    "cluster.store.promote",
    "cluster.store.read",
    "cluster.update",
    "credential.create",
    "credential.delete",
    "credential.exportRecovery",
    "credential.read",
    "credential.rotate",
    "credential.update",
    "dhcpservice.manage",
    "dhcpservice.read",
    "directoryrealm.manage",
    "directoryrealm.read",
    "enclosure.failover",
    "enclosure.read",
    "enclosure.write",
    "fileshare.audit.read",
    "fileshare.browse",
    "fileshare.catalog.credentials",
    "fileshare.catalog.export",
    "fileshare.catalog.read",
    "fileshare.catalog.scan",
    "fileshare.create",
    "fileshare.delete",
    "fileshare.lockdown",
    "fileshare.promote",
    "fileshare.read",
    "fileshare.remount",
    "fileshare.snapshot.create",
    "fileshare.snapshot.delete",
    "fileshare.snapshot.read",
    "fileshare.snapshot.update",
    "fileshare.update",
    "fileshare.write",
    "host.create",
    "host.delete",
    "host.read",
    "host.update",
    "ioserverpair.create",
    "ioserverpair.credential",
    "ioserverpair.delete",
    "ioserverpair.fence",
    "ioserverpair.read",
    "ioserverpair.update",
    "monitoring.manage",
    "monitoring.read",
    "multiscsicluster.create",
    "multiscsicluster.delete",
    "multiscsicluster.grow",
    "multiscsicluster.read",
    "multiscsicluster.scrub",
    "multiscsicluster.update",
    "network.manage",
    "network.read",
    "objectstore.audit.read",
    "objectstore.manage",
    "objectstore.read",
    "raid.create",
    "raid.delete",
    "raid.read",
    "rbac.read",
    "rbac.role.create",
    "rbac.role.delete",
    "rbac.role.update",
    "replication.create",
    "replication.delete",
    "replication.demote",
    "replication.promote",
    "replication.read",
    "replication.sync",
    "replication.update",
    "s3account.manage",
    "scope.create",
    "scope.delete",
    "scope.read",
    "scope.report",
    "scope.update",
    "synclink.adopt",
    "synclink.create",
    "synclink.delete",
    "synclink.demote",
    "synclink.promote",
    "synclink.read",
    "target.create",
    "target.delete",
    "target.read",
    "target.update",
    "task.abort",
    "task.cancel",
    "task.read",
    "task.resume",
    "user.create",
    "user.delete",
    "user.mfa.reset",
    "user.password.set",
    "user.read",
    "user.sessions.revoke",
    "user.unlock",
    "user.update",
    "vdisk.create",
    "vdisk.delete",
    "vdisk.expand",
    "vdisk.read",
    "volume.create",
    "volume.delete",
    "volume.diff",
    "volume.expand",
    "volume.failover",
    "volume.forcePromote",
    "volume.migrateFilesystem",
    "volume.promote",
    "volume.read",
    "volume.revert",
    "volume.snapshot.create",
    "volume.snapshot.delete",
    "volume.snapshot.read",
    "volume.syncAttach",
    "volume.syncDegrade",
    "volume.update",
] as const;

export type Permission = (typeof PERMISSION_CATALOG)[number];
